<template>
  <SectionTransformTable>
    <PaymentForDistribution
      :api-code="AP_UPD01"
      :dataPayment="detailPaymentData"
      :paymentId="detailData?.Id"
      @accept-data="
        (value) => {
          const convertedValue = {
            ...value,
            ApPaymentId: value.ArPaymentId,
          };
          delete convertedValue.ArPaymentId;

          const body = {
            ApPaymentDetail: convertedValue,
          };
          acceptDataSaveForBill(body);
        }
      "
      @accept-data-edit="
        (value) => {
          const convertedValue = {
            ...value,
            ApPaymentId: value.ArPaymentId,
          };
          delete convertedValue.ArPaymentId;

          const body = {
            ApPaymentDetail: convertedValue,
          };
          acceptDataEditForBill(body);
        }
      "
    />

    <ModalListPayAp
      v-if="detailData"
      @refetch="
        (data) =>
          fetchDetailApPayment({
            ApPayment: {
              Id: data.data.Id,
            },
          })
      "
      :isShow.sync="isShowModalListPayAp"
      :data="detailData"
    />
    <SearchList @search="refetchData" :title="'ap_client_list_pay'" buttonText="ar_common_search">
      <FormItems :formData.sync="searchVal" :items="formItems" />
    </SearchList>
    <b-card>
      <!--  <div class="d-flex justify-content-end mb-1">
        <b-button
          :disabled="selectedPayment.length === 0"
          variant="success"
          @click="() => approveListPay()"
        >
          <ez-icon icon="ezGolf-icon-plus-circle" />
          {{ $t("ap_client_approve") }}
        </b-button>
      </div> -->

      <EzTable
        ref="tableRef"
        :actions="actions"
        :selectionConfig="{
          hideSelectAll: true,
        }"
        @action-1="
          (data) =>
            fetchDetailApPayment({
              ApPayment: {
                Id: data.data.Id,
              },
            })
        "
        @action-2="(data) => deletePayment({ ApPayment: { Id: data.data.Id } })"
        :excelExport="arClient.api_ExcelAP_RP01"
        :excel-export-api-code="AP_RP03"
        @selection-changed="onSelectionChanged"
        :isLoading="isLoading"
        :columns="listPayApColumns"
        :dataSourceParams="searchVal"
        :dataSource="arClient.api_AP_RP01"
      >
        <template #toolbar>
          <div class="d-flex">
            <PermissionButton
              :api-code="AP_UP02"
              variant="outline-primary"
              @click="handleApproveListPay"
            >
              <ez-icon icon="ezAr-icon-navigation" />
              {{ $t("ap_client_approve") }}
            </PermissionButton>
            <PermissionButton
              :api-code="AP_UP04"
              style="margin-left: 6px"
              variant="outline-primary"
              @click="handleConfirmListPay"
            >
              <ez-icon icon="ezAr-icon-check" />
              {{ $t("golf_common_confirm") }}
            </PermissionButton>
          </div>
        </template>
      </EzTable>
    </b-card>
    <SidebarSection width="900px" title="ap_client_detail" :isShow.sync="isShowSidebar">
      <div class="mt-1">
        <b-row class="m-0 mb-1">
          <b-col md="6">
            <h6 class="content-title">
              {{ $t("ar_voucher_general_information") }}
            </h6>
          </b-col>
          <b-col md="6" class="d-flex justify-content-end">
            <ez-icon
              :class="{ 'd-none': !isValidPermission(AP_UP01) }"
              icon="ezAr-icon-edit"
              size="24"
              class="cursor-pointer mx-50"
              color="#114A9F"
              @click="isShowModalListPayAp = true"
            />
          </b-col>
        </b-row>
        <GeneralInfo leftWidth="160px" rightWidth="80px" :list="listGeneral" />
      </div>
      <div class="divider"></div>
      <h6 class="mb-2 mt-1 ml-1">
        {{ $t("ar_client_selected_list_account") }}
      </h6>
      <div class="px-1">
        <EzTable
          :toolbarConfig="{ disableToolbar: true }"
          :pageConfig="{ disablePagination: true }"
          :columns="listAccountColumns"
          :dataSource="detailData.ApPaymentDistribution"
        />
      </div>
      <div class="divider"></div>
      <div class="mb-2 mt-1 mx-1 d-flex justify-content-between">
        <h6>
          {{ $t("ar_client_list_payment") }}
        </h6>
        <PermissionButton
          :api-code="AP_RPD01"
          :disabled="isFutureDate(detailData.PaymentDate)"
          variant="primary"
          @click="() => handleShowPayment()"
        >
          <ez-icon icon="ezAr-icon-plus-circle" /><span style="margin-left: 3px">
            {{ $t("ar_client_add_pay") }}</span
          >
        </PermissionButton>
      </div>
      <div class="px-1 pb-3">
        <EzTable
          :toolbarConfig="{ disableToolbar: true }"
          :pageConfig="{ disablePagination: true }"
          @action-1="(data) => handleShowPayment(data.data.Id)"
          @action-2="(data) => deleteApPayment({ ApPaymentDetail: { Id: data.data.Id } })"
          :actions="paymentActions"
          :columns="listPaymentColumns"
          :dataSource="detailData.ListApPaymentDetail"
        />
      </div>
    </SidebarSection>
  </SectionTransformTable>
</template>
<style lang="scss" scoped>
::v-deep .detail-sidebar {
  label {
    display: inline-block;
  }
  label.left-width {
    width: 120px;
  }
  label.right-width {
    width: 80px;
  }
}
.divider {
  height: 12px;
  background-color: rgba(193, 193, 193, 0.12);
}
</style>
<script>
import { arClient } from "@/api/ar-client";
import ModalListPayAp from "./components/ModalListPayAp.vue";
import SidebarSection from "../ultils/Sidebar/SidebarSection.vue";
import FormItems from "../ultils/Form/FormItems.vue";
import PermissionButton from "../ultils/Button/PermissionButton.vue";
import { convertApPaymentStatus } from "../ultils/status";
import SidebarLabel from "@/modules/SidebarLabel.vue";

import ModalBoxAddBill from "../ListPayAr/components/SidebarViewPayment/components/ModalBoxAddBill.vue";

import SearchList from "../ultils/SearchList/SearchList.vue";
import SectionTransformTable from "../ultils/Section/SectionTransformTable.vue";
import PaymentForDistribution from "../ultils/PaymentForm/PaymentForDistribution.vue";
import { ApPaymentStatus } from "../ultils/status";
import EzTable from "../ultils/Table/EzTable.vue";
import { VoucherService } from "@/api/voucher-service";
import { useFetch } from "../ultils/Hooks/useFetch.ts";
import GeneralInfo from "../ultils/General/GeneralInfo.vue";
import { defineComponent, ref, getCurrentInstance } from "@vue/composition-api";
import {
  AP_DP01,
  AP_DPD01,
  AP_RP02,
  AP_RPD01,
  AP_RP03,
  AP_UP02,
  AP_UP04,
  AP_UPD01,
  AP_UP01,
} from "@/api/constant";

export default defineComponent({
  components: {
    PermissionButton,
    GeneralInfo,
    PaymentForDistribution,
    SectionTransformTable,
    EzTable,
    FormItems,

    SearchList,
    ModalBoxAddBill,
    SidebarSection,
    SidebarLabel,
    ModalListPayAp,
  },
  setup(props, { refs }) {
    const vm = getCurrentInstance().proxy;
    const selectedPayment = ref([]);
    const tableRef = ref(null);
    const actions = ref([
      {
        apiCode: AP_RP02,
        title: "ar_common_detail",
        icon: "eye",
      },
      {
        apiCode: AP_DP01,
        title: "ar_common_delete",
        icon: "trash",
        danger: true,
      },
    ]);

    const searchVal = ref({});
    const isShowSidebar = ref(false);

    function onSelectionChanged(data) {
      selectedPayment.value = data.selectedRowsData.map((d) => d.Id);
    }
    function refetchData() {
      tableRef.value.fetchData();
    }
    const { fetchData: fetchDetailApPayment, data: detailData } = useFetch(arClient.api_AP_RP02, {
      nextFunction: () => {
        isShowSidebar.value = true;
      },
      defaultData: {},
    });

    const { fetchData: deletePayment } = useFetch(arClient.api_AP_DP01, {
      showLoading: true,
      loadingMessage: "ar_common_deleting",
      nextFunction: () => {
        refetchData();
        isShowSidebar.value = false;
      },
    });
    const { fetchData: deleteApPayment } = useFetch(arClient.api_AP_DPD01, {
      showLoading: true,
      loadingMessage: "ar_common_deleting",
      nextFunction: () => {
        refetchData();
        fetchDetailApPayment({
          ApPayment: {
            Id: detailData.value.Id,
          },
        });
      },
    });
    const { fetchData: acceptDataEditForBill, isLoading: isUpdatePayment } = useFetch(
      arClient.api_AP_UPD01,
      {
        showLoading: true,

        nextFunction: () => {
          vm.$bvModal.hide("modal-payment-for-distribution");
          fetchDetailApPayment({
            ApPayment: {
              Id: detailData.value.Id,
            },
          });
          refetchData();
        },
      }
    );

    const { fetchData: fetchDetailPayment, data: detailPaymentData } = useFetch(
      arClient.api_AP_RPD01,
      {
        nextFunction: () => {
          isShowSidebar.value = true;
        },
      }
    );
    const { fetchData: acceptDataSaveForBill, isLoading: isCreatePayment } = useFetch(
      arClient.api_AP_IPD01,
      {
        showLoading: true,

        nextFunction: () => {
          vm.$bvModal.hide("modal-payment-for-distribution");
          fetchDetailApPayment({
            ApPayment: {
              Id: detailData.value.Id,
            },
          });
          refetchData();
        },
      }
    );
    const { fetchData: confirmListPay } = useFetch(arClient.api_AP_UP04, {
      showLoading: true,
      loadingMessage: "ar_common_confirming",
      nextFunction: refetchData,
    });
    const { fetchData: approveListPay } = useFetch(
      arClient.api_AP_UP02,

      { showLoading: true, loadingMessage: "ar_common_approving...", nextFunction: refetchData }
    );
    const openDeleteDialog = () => {
      const deleteDialogRef = tableRef.value.$refs.deleteDialog[0];

      deleteDialogRef.open({
        data: { Id: detailData.value.Id },
      });
    };
    return {
      AP_UPD01,
      AP_UP01,
      AP_UP04,
      AP_UP02,
      AP_RPD01,
      AP_RP03,
      isCreatePayment,
      isUpdatePayment,
      openDeleteDialog,
      confirmListPay,
      deleteApPayment,
      fetchDetailApPayment,
      detailData,
      fetchDetailPayment,
      acceptDataSaveForBill,
      isShowSidebar,
      acceptDataEditForBill,
      approveListPay,
      selectedPayment,
      refetchData,
      detailPaymentData,
      onSelectionChanged,
      deletePayment,
      actions,
      searchVal,

      tableRef,
    };
  },
  data() {
    return {
      isShowModalPayment: false,
      isShowModalListPayAp: false,
      paymentActions: [
        {
          apiCode: AP_RPD01,
          title: "ar_common_detail",
          icon: "eye",
        },
        {
          danger: true,
          apiCode: AP_DPD01,
          icon: "trash",
          title: "ar_common_delete",
        },
      ],

      isShowAddNewBill: false,
      listPaymentColumns: [
        {
          caption: "ar_client_payment_date",
          field: "PaymentDetailDate",
          cellTemplate: true,
          formatType: "date",
        },
        {
          caption: "ar_client_cashier",
          field: "CashierName",
          cellTemplate: true,
          cellRender(data) {
            return `${data.data.CashierCode} - ${data.data.CashierName}`;
          },
        },
        {
          caption: "ar_client_payment_type",
          field: "PaymentDetailType",
          cellTemplate: true,
          align: "center",
          cellRender(data) {
            return "Thanh toán";
          },
        },
        {
          caption: "ar_client_payments",
          field: "PaymentMethodName",
        },
        {
          caption: "ar_client_amount",
          field: "Amount",
          cellTemplate: true,
          formatType: "num",
        },
        {
          caption: "ar_client_currency_code",
          field: "CurrrencyFormat",
        },
      ],

      isLoading: false,

      listPayment: [],
      formItems: [
        {
          type: "string",
          name: "PaymentCode",
          label: "ap_client_payment_code",
          placeholder: "ap_client_payment_code",
          wrapperClass: "col-2",
        },
        {
          type: "string",
          name: "DistributionCode",
          label: "ar_client_distribution_code",
          placeholder: "ar_client_distribution_code",
          wrapperClass: "col-2",
        },

        {
          type: "select",
          name: "PropertyId",
          multiple: true,
          dataSource: arClient.api_AR_RPE01,
          dataSourceParams: {
            IsCheckPermission: false,
          },
          customOptions: (options) =>
            options.map((option) => ({
              ...option,
              CodeName: `${option.PropertyCode} - ${option.PropertyName}`,
            })),
          labelOption: "CodeName",

          label: "ar_client_site_code",
          placeholder: "ar_client_site_code",
          wrapperClass: "col-3",
        },

        {
          type: "string",
          name: "TravelAgentName",

          label: "ar_client_company_name",
          wrapperClass: "col-2",
        },
        {
          type: "string",
          name: "ArAccountCode",
          placeholder: "ar_client_debit_account_code",
          label: "ar_client_debit_account_code",
          wrapperClass: "col-2",
        },
        {
          type: "select",
          name: "ApPaymentStatus",
          dataSource: ApPaymentStatus.map((i) => ({ ...i, title: this.$t(i.title) })),
          multiple: true,
          customReduce: "value",
          labelOption: "title",
          placeholder: "ar_client_status",
          label: "ar_client_status",
          wrapperClass: "col-2",
        },
        {
          type: "date",
          rangeData: ["FromDate", "ToDate"],
          name: "createdDate",
          isRange: true,
          placeholder: "ap_client_created_date",
          label: "ap_client_created_date",
          wrapperClass: "col-3",
        },
      ],
      listCashier: [],
      dataArClient: [],
      ClientSearchVal: null,

      listAccountColumns: [
        {
          caption: "ar_client_company",
          field: "TravelAgentName",
          width: "32%",
        },
        {
          caption: "ar_client_account_code",
          field: "AccountCode",
          width: "17%",
        },
        {
          caption: "ar_client_distribution_code",
          field: "DistributionCode",
          width: "17%",
        },
        {
          caption: "ar_client_distribution_amount",
          cellTemplate: true,
          formatType: "currency",
          field: "TotalAmount",
          width: "17%",
        },
        {
          caption: "ar_client_distribution_date",
          field: "CreatedDate",
          cellTemplate: true,
          formatType: "date",
          width: "17%",
        },
      ],
      listPayApColumns: [
        {
          caption: "ap_client_payment_code",
          field: "ApPaymentCode",
          minWidth: "130px",
        },
        {
          caption: "ar_client_distribution_code",
          field: "DistributionCode",
          minWidth: "130px",
        },
        {
          caption: "ar_client_agency",
          field: "TravelAgent",

          minWidth: "150px",
        },

        {
          caption: "ar_client_site_code",
          field: "PropertyName",
          cellTemplate: true,
          cellRender(data) {
            return `${data.data.PropertyCode || "N/A"} - ${data.data.PropertyName}`;
          },
          minWidth: "12%",
        },
        {
          caption: "ar_client_debit_account_code",
          field: "AccountCode",
          minWidth: "130px",
        },
        {
          caption: "ap_client_payment_amount",
          field: "TotalAmount",
          cellTemplate: true,
          formatType: "currency",
          minWidth: "9%",
        },
        {
          caption: "ar_client_receipt_amount",
          cellTemplate: true,
          formatType: "currency",
          field: "ApPaymentDetailAmount",
          minWidth: "9%",
        },

        /*  {
          caption: "ap_client_account_code",
          field: "PaymentDetailAmount",
        }, */
        {
          caption: "ar_client_status",
          minWidth: "8%",
          field: "Status",
          cellTemplate: true,
          formatType: "text-variant",
          renderTextVariant: convertApPaymentStatus,
        },
        {
          caption: "ar_client_created_person",
          cellTemplate: true,
          cellRender(data) {
            return `${data.data.CashierCode} - ${data.data.CashierName}`;
          },
          field: "CashierName",
          minWidth: "12%",
        },
        {
          caption: "ap_client_created_date",
          formatType: "date",
          minWidth: "8%",
          cellTemplate: true,
          field: "ApPaymentDate",
        },
      ],
    };
  },
  methods: {
    isFutureDate(date) {
      return !this.dayjs().isSame(this.dayjs(date), "day");
    },
    handleApproveListPay() {
      if (this.selectedPayment.length === 0) {
        this.showToast("error", "Hãy chọn phiếu chi để duyệt");
        return;
      }
      this.approveListPay({
        ApPayment: {
          Id: this.selectedPayment,
        },
      });
    },
    handleConfirmListPay() {
      if (this.selectedPayment.length === 0) {
        this.showToast("error", "Hãy chọn phiếu chi để xác nhận");
        return;
      }
      this.confirmListPay({
        ApPayment: {
          Id: this.selectedPayment,
        },
      });
    },
    handleShowPayment(Id) {
      if (Id) {
        this.fetchDetailPayment({
          ApPaymentDetail: {
            Id,
          },
        });
      } else {
        this.detailPaymentData = null;
      }

      this.$root.$emit("bv::show::modal", "modal-payment-for-distribution");
    },

    async fetchListPayments() {
      const body = {
        ZoneId: ["24"],
      };
      await arClient.api_AR_RMT01(body).then((res) => {
        this.listPayment = [...res.Data.PaymentType];
      });
    },

    openModal() {
      this.isShowModalListPayAp = true;
    },
  },
  computed: {
    listGeneral() {
      return [
        {
          icon: "code",
          label: "ap_client_payment_code",
          content: this.detailData?.PaymentCode,
        },
        {
          icon: "calendar",
          label: "ar_client_created_date",
          content: this.formatDate(this.detailData.PaymentDate),
        },
        {
          icon: "user",
          label: "ar_client_cashier",
          content: `${this.detailData?.CashierCode} - ${this.detailData?.CashierName}`,
        },
        {
          icon: "plus-circle",
          label: "ar_client_site_code",
          content: `${this.detailData?.PropertyCode} - ${this.detailData?.PropertyName}`,
        },
        {
          icon: "dollar-sign",
          label: "ar_client_total_money",
          afterFixLabel: `(VND)`,
          content: this.formatPrice(this.detailData?.TotalAmount),
        },
        {
          icon: "bar-chart-2",
          label: "ar_client_status",
          content: this.$t(convertApPaymentStatus(this.detailData?.Status).title),
          variant: this.$t(convertApPaymentStatus(this.detailData?.Status).variant),
        },
        {
          icon: "dollar-sign",
          label: "ar_client_total_money_payment",
          afterFixLabel: `(VND)`,
          content: this.formatPrice(
            this.detailData?.ListApPaymentDetail?.reduce((acc, v) => {
              return (acc += v.Amount);
            }, 0)
          ),
        },
        {
          icon: "file-text",
          label: "ar_client_note",
          content: this.detailData?.Note,
        },
      ];
    },
    convertedApPayment() {
      const tempPayment = this.listPayment[0]?.PaymentMethod;
      return this.data.ApPayment.map((item) => ({
        ...item,
        PaymentMethodName: tempPayment?.find((p) => p.Id === item.PaymentMethodId)?.Name,
      }));
    },
  },
});
</script>
